import React from "react";
import { useHistory } from "react-router";

function Page404() {
  const history = useHistory();
  return (
    <div
      className={
        "d-flex justify-content-center align-items-center mt-5 flex-column pt-5"
      }
    >
      <h2>Oops ! Page not Found</h2>
      <button
        className='btn btn-link'
        onClick={() => {
          history.push("/");
        }}
      >
        Go Home
      </button>
    </div>
  );
}

export default Page404;
